export default __webpack_public_path__ + "media/images/to-google-store-100-fr-751d8ee50dc90ac29b2acabc74f5f44d.png";